<template>
    <div class="ah-page revenue-goal-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>營收目標設定</h1>
                    </div>
                    <div class="actions">
                        <el-button v-if="!isQR()" type="highlight" @click="onAdd">
                            新增營收目標
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <el-table
                        v-loading="status == 'loading'"
                        :data="datas"
                        style="width: 100%"
                        class="row-click ah-el-data-table"
                        @row-click="onEdit"
                        :default-sort="{ prop: 'year', order: 'descending' }"
                        empty-text="沒有資料"
                    >
                        <el-table-column prop="year" label="年度" sortable>
                            <template slot-scope="scope">
                                <div class="strong">{{ scope.row.year }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="kpi" label="全年營收目標" sortable align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.kpi" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="cny" label="幣別" align="right" width="80">
                            <template slot-scope=""> TWD </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Money from '@/components/ui/Money.vue';

export default {
    name: 'RevenueGoal',
    components: {
        Money,
    },
    data() {
        return {
            showEditDialog: false,
            status: '',
            datas: [],
            selectedYear: null,
            errorMsg: '',
        };
    },
    created() {
        this.updateData();
    },
    methods: {
        closeDialog(refresh) {
            if (refresh) this.updateData();
            this.selectedYear = null;
            this.showEditDialog = false;
        },
        // 更新客戶（顯示頁面時觸發）
        updateData() {
            this.status = 'loading';
            this.errorMsg = '';

            // 開始取得資料
            this.$api({
                url: 'RevenueTargetSettingPage/GetList',
                method: 'GET',
            })
                // 取得成功
                .then((resp) => {
                    this.status = 'success';

                    // 更新資料
                    this.datas = resp.data.items;
                });
        },

        // 顯示錯誤訊息
        showErrorMsg(msg) {
            this.errorMsg = msg;
        },

        onAdd() {
            this.$router.push({ name: 'revenue-goal-add' });
        },
        onEdit({ year }) {
            this.$router.push({
                name: 'revenue-goal-edit',
                params: { year },
            });
        },
    },
};
</script>
<style lang="scss" scoped="">
@import "@/assets/scss/vars.scss";
</style>
